import { useEffect, useRef, useState } from "react"
import Button from "@ui/button/Button"
import { systemPost } from "src/services/superAdminApi"
import { Callout, FilterBar, Page, Panel, State } from "./adminUi"
import { UserOverviewData } from "./UserOverviewData"

export const SuperAdminTransactionDetails = ({ token }: { token: string }) => {
	const [operation, setOperation] = useState("")
	const [loading, setLoading] = useState(false)
	const [result, setResult] = useState<unknown>()
	const [error, setError] = useState("")
	const generation = useRef(0)
	const busy = useRef(false)
	useEffect(() => {
		generation.current++
		busy.current = false
		setLoading(false)
		setResult(undefined)
		setError("")
		return () => { generation.current++ }
	}, [token])
	const load = async () => {
		if (busy.current) return
		const operationId = Number(operation)
		if (!/^\d+$/.test(operation) || !Number.isSafeInteger(operationId) || operationId <= 0) {
			setResult(undefined)
			setError("Invalid operation number")
			return
		}
		const current = ++generation.current
		busy.current = true
		setLoading(true)
		setError("")
		setResult(undefined)
		const response = await systemPost<unknown>(token, "system/transactions/details", { operation_id: operationId })
		if (current !== generation.current) return
		busy.current = false
		setLoading(false)
		setResult(response)
		if (response.error) {
			const title = response.error.code === 3020 ? "Operation not found"
				: response.error.code === 1 ? "Invalid operation number"
				: response.error.code === 200 ? "TRX is unavailable, please try again later"
				: "Could not load transaction details"
			setError([title, String(response.error.details || response.error.message || "")].filter(Boolean).join(": "))
		}
	}
	return <Page>
		<Panel title="Transaction lookup" hint="Loads the TRX operation together with the live issuer response.">
			<form onSubmit={event => { event.preventDefault(); void load() }}>
				<FilterBar>
					<label style={{ flex: "0 1 260px" }}>Operation ID<input name="operation_id" inputMode="numeric" placeholder="e.g. 12345" value={operation} onChange={event => setOperation(event.target.value)} disabled={loading} style={{ width: "100%" }} /></label>
					<Button title="Load details" variant="primarySmall" onClick={() => void load()} disabled={loading} />
				</FilterBar>
			</form>
		</Panel>
		{loading && <Panel title="Loading transaction" hint="Loading TRX and live issuer response…"><State loading /></Panel>}
		{error && <Callout tone='danger'>{error}</Callout>}
		{result !== undefined && <Panel title="Transaction details"><div aria-label="Complete transaction response"><UserOverviewData value={result} /></div></Panel>}
	</Page>
}
